import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonNew as Button } from "components/buttonNew";
import React from "react";
import "./emptyStatus.scss";

interface IProps {
  title: string;
  icon?: IconDefinition;
  description?: string;
  action?: { label: string; onClick: () => void };
}

export default function EmptyStatus(props: IProps) {
  const { title, icon, description, action } = props;
  return (
    <div className="ui-empty-status">
      {icon ? (
        <div className="ui-empty-status-icon">
          <div>
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
      ) : null}
      <div>
        <p className="ui-empty-status-title">{title}</p>
        {description ? <p className="ui-empty-status-description">{description}</p> : null}
      </div>
      {action ? (
        <Button type="primary" size="small" onClick={action?.onClick}>
          {action?.label}
        </Button>
      ) : null}
    </div>
  );
}
